import ApiService from '../services/api.service'
import { PlcModel } from './models'

export default {
  async loadPlcs(): Promise<PlcModel[]> {
    const response = await ApiService.get(`${ApiService.backendEnvironmentConfiguration().projectApi}/Plcs`)
    return response.data.value
  },
}
